module.exports = __webpack_public_path__ + "img/setting.6896f108.svg";